import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [

    {
      path: '/',
      redirect: {
        name:'Home'
      },
      component:()=>import('../components/monitoring/navigation'),

      children:[
        {
          path: '/Home',
          name:'Home',
          component:()=>import('../components/home/home'),
        },
       
        {
          path:'/JoinUs',
          name:'JoinUs',
          component:()=>import('../components/JoinUs/JoinUs.vue'),
          children:[
            {
              path: '/InvestmentAgent',
              name:'InvestmentAgent',
              component:()=>import('../components/JoinUs/InvestmentAgent.vue'),
            },
            {
              path: '/TalentRecruitment',
              name:'TalentRecruitment',
              component:()=>import('../components/JoinUs/TalentRecruitment.vue'),
            },
          ]
        },
       {
        path:'/About',
        name:'About',
        component:()=>import('../components/about/about'),
        children:[
          {
            path:'/Contact',
               name:"Contact",
               component:()=>import('../components/about/contact')
           },
           {
             path:'/Introduction',
                name:"Introduction",
                component:()=>import('../components/about/Introduction')
            },
            {
             path:'/Opinion',
                name:"Opinion",
                component:()=>import('../components/about/opinion')
            },
            {
             path:'/Team',
                name:"Team",
                component:()=>import('../components/about/team')
            }
        ]
       },
       {
        path:'/Member',
        name:'Member',
        component:()=>import('../components/member/member.vue'),
        children:[
          {
            path:'/Clause',
            name:'Clause',
            component:()=>import('../components/member/Clause.vue'),
          },
          {
            path:'/Privacy',
            name:'Privacy',
            component:()=>import('../components/member/Privacy.vue'),
          },
          {
            path:'/Mall',
            name:'Mall',
            component:()=>import('../components/member/Mall.vue'),
          },
          {
            path:'/Description',
            name:'Description',
            component:()=>import('../components/member/Description.vue'),
          },
        ]
       },
      
     
       ,
       {
        path:'/information',
        name:'information',
        component:()=>import('../components/information/information.vue'),
        children:[
          {
            path:'/announcement',
            name:'announcement',
            component:()=>import('../components/information/announcement.vue'),
          },
          {
            path:'/industry',
            name:'industry',
            component:()=>import('../components/information/industry.vue'),
          },
        ]
       },
       {
        path:'/myShoop',
        name:'myShoop',
        component:()=>import('../components/myShoop/myShoop.vue'),
        
       },
      
      
       {
        path:'/Academic',
        name:'Academic',
        component:()=>import('../components/Academic/Academic.vue'),
        children:[
          {
            path:'/APPlication',
        name:'APPlication',
        component:()=>import('../components/Academic/APPlication.vue'),
          },
          {
            path:'/Reference',
        name:'Reference',
        component:()=>import('../components/Academic/Reference.vue'),
          },
          {
            path:'/Technical',
        name:'Technical',
        component:()=>import('../components/Academic/Technical.vue'),
          },
          {
            path:'/Video',
        name:'Video',
        component:()=>import('../components/Academic/Video.vue'),
          },
        ]
       },
       { path:'/distribution',
       name:'distribution',
       component:()=>import('../components/distribution/distribution.vue'),
       children:[
        {
          path:'/Distributioninstructions',
          name:'Distributioninstructions',
          component:()=>import('../components/distribution/Distributioninstructions.vue'),
        },
        {
          path:'/Checkandreceive',
          name:'Checkandreceive',
          component:()=>import('../components/distribution/Checkandreceive.vue'),
        },
        {
          path:'/Q&A',
          name:'Q&A',
          component:()=>import('../components/distribution/Q&A.vue'),
        }
       ]
       },
       {
        path:'/Shoppingguide',
       name:'Shoppingguide',
       component:()=>import('../components/Shoppingguide/Shoppingguide.vue'),
       children:[
        {
          path:'/Orderprocessing',
          name:'Orderprocessing',
          component:()=>import('../components/Shoppingguide/Orderprocessing.vue'),
       },
       {
        path:'/Termsofpayment',
        name:'Termsofpayment',
        component:()=>import('../components/Shoppingguide/Termsofpayment.vue'),
        },
        {
        path:'/Shoppingproblem',
        name:'Shoppingproblem',
        component:()=>import('../components/Shoppingguide/Shoppingproblem.vue'),
      },
      {
        path:'/Purchaseprocess',
        name:'Purchaseprocess',
        component:()=>import('../components/Shoppingguide/Purchaseprocess.vue'),
      },
       ]
       },
       {
        path:'/Aftersale',
       name:'Aftersale',
       component:()=>import('../components/Aftersale/Aftersale.vue'),
       children:[
        {
          path:'/Returngoods',
          name:'Returngoods',
          component:()=>import('../components/Aftersale/Returngoods.vue'),
       },
       {
        path:'/Refundinstructions',
        name:'Refundinstructions',
        component:()=>import('../components/Aftersale/Refundinstructions.vue'),
        },
        {
        path:'/Invoicespecification',
        name:'Invoicespecification',
        component:()=>import('../components/Aftersale/Invoicespecification.vue'),
      },
      {
        path:'/Aftersalescontact',
        name:'Aftersalescontact',
        component:()=>import('../components/Aftersale/Aftersalescontact.vue'),
      },
       ]
       }
    ],
    },
    {
      path: '/Login',
      component:()=>import('../components/login/login'),
    },
    {
      path: '/Column',
      component:()=>import('../components/column/column'),
    },
    {
      path:'/checkstand',
      name:'checkstand',
      component:()=>import('../components/myShoop/checkstand.vue')
    },
    {
      path:'/confirmation',
      name:'confirmation',
      component:()=>import('../components/myShoop/confirmation.vue')
    },
    {
      path:'/index',
      component:()=>import('../components/details/index.vue'),
      children:[
        {
          path:'/user',
          name:'user',
          redirect: {
            name:'userorder'
          },
          component:()=>import('../components/user/user.vue'),
          children:[{
            path: '/userorder',
            name:'userorder',
            component:()=>import('../components/user/order.vue'),
          },
          {
            path: '/usershoopcar',
            name:'usershoopcar',
            component:()=>import('../components/user/shoopcar.vue'),
          },
          {
            path: '/userinvoice',
            name:'userinvoice',
            component:()=>import('../components/user/invoice.vue'),
          },
          {
            path: '/userintegral',
            name:'userintegral',
            component:()=>import('../components/user/integral.vue'),
          },
          {
            path: '/userexchange',
            name:'userexchange',
            component:()=>import('../components/user/exchange.vue'),
          },
          {
            path: '/usercustomize',
            name:'usercustomize',
            component:()=>import('../components/user/customize.vue'),
          },
          {
            path: '/usercollect',
            name:'usercollect',
            component:()=>import('../components/user/collect.vue'),
          },
          {
            path: '/useraddress',
            name:'useraddress',
            component:()=>import('../components/user/address.vue'),
          },
          ]
         },
        {
          path:'/details',
          name:'/details',
          component:()=>import('../components/details/details.vue'),
        },
        {
          path:'/details2',
          name:'/details2',
          component:()=>import('../components/details/details2.vue'),
        },
        {
          path:'/Customize',
          name:'/Customize',
          component:()=>import('../components/details/customize.vue')
        },
        {
          path:'/orderDetails',
          name:'orderDetails',
          component:()=>import('../components/details/orderDetails.vue')
        },
        {
          path:'/complaint',
          name:'complaint',
          component:()=>import('../components/details/complaint.vue')
        },
        {
          path:'/productIndex',
          name:'productIndex',
          component:()=>import('../components/Product/productIndex.vue')
         },
         {
          path:'/Product',
          name:'Product',
          component:()=>import('../components/Product/Product.vue'),
          children:[
            {
              path:'/Primary',
              name:'Primary',
              component:()=>import('../components/Product/Primary.vue'),
            },
            {
              path:'/Secondary',
              name:'Secondary',
              component:()=>import('../components/Product/Secondary.vue'),
            },
            {
              path:'/Homologous',
              name:'Homologous',
              component:()=>import('../components/Product/Homologous.vue'),
            },
            {
              
              path:'/Recombinant',
              name:'Recombinant',
              component:()=>import('../components/Product/Recombinant.vue'),
            },
            {
              
              path:'/Whole',
              name:'Whole',
              component:()=>import('../components/Product/Whole.vue'),
            },
          ]
         },
         {
          path:'/webUser',
          name:'webUser',
          component:()=>import('../components/web-user/webUser.vue'),
        
          
          
         },
         {
          path:'/webshezhi',
          name:'webshezhi',
          component:()=>import('../components/web-user/webshezhi.vue'),
  
         },
         {
          path: '/webuserorder',
          name:'webuserorder',
          component:()=>import('../components/web-user/webuserorder.vue'),
        },
        {
          path: '/webcollect',
          name:'webcollect',
          component:()=>import('../components/web-user/webcollect.vue'),
        },
        {
          path: '/webinvoice',
          name:'webinvoice',
          component:()=>import('../components/web-user/webinvoice.vue'),
        },
        {
          path: '/webaddress',
          name:'webaddress',
          component:()=>import('../components/web-user/webaddress.vue'),
        },
        {
          path: '/webexchange',
          name:'webexchange',
          component:()=>import('../components/web-user/webexchange.vue'),
        },
        {
          path: '/webcustomize',
          name:'webcustomize',
          component:()=>import('../components/web-user/webcustomize.vue'),
        },
        {
          path: '/webshoopcar',
          name:'webshoopcar',
          component:()=>import('../components/web-user/webshoopcar.vue'),
        },
        {
          path: '/webintegral',
          name:'webintegral',
          component:()=>import('../components/web-user/webintegral.vue'),
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js